// src/pages/LogIn.js
import React, { useState, useContext } from 'react';
import { GlobalContext } from '../contexts/GlobalContext';
import { useNavigate } from 'react-router-dom';
import './LogIn.css';

function LogIn() {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [showForgotPassword, setShowForgotPassword] = useState(false);
    const [error, setError] = useState('');
    const navigate = useNavigate();
    const { setIsLoggedIn, setUserLevel, setGlobalUsername, setUserFullName } = useContext(GlobalContext);

    const handleLogin = async (e) => {
        e.preventDefault();
        setError('');
        try {
            const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/login`, {
                method: 'POST',
                credentials: 'include', // Include credentials (cookies)
                headers: {'Content-Type': 'application/json',},
                body: JSON.stringify({ username, password }),
            });
            const data = await response.json();
            if (response.ok) {
                setIsLoggedIn(true);
                setUserLevel(data.userLevel);
                setGlobalUsername(data.username);
                setUserFullName(data.fullname);
                console.log(data);
                if (data.userLevel == '2') {
                    navigate('/bible-study-materials'); // Redirect to BibleStudyMaterials page
                } else if (data.userLevel == '1') {
                    navigate('/admin');
                } else {
                    navigate('/');
                }
            } else {
                setError(data.error || 'Login failed.');
            }
        } catch (error) {
            console.error('Error during login:', error);
            setError('An error occurred during login.');
        }
    };

    const handleForgotPassword = () => {
        setShowForgotPassword(true);
    };

    const handleBackToLogin = () => {
        setShowForgotPassword(false);
        setError('');
    };

    return (
        <div className="page-content">
        {!showForgotPassword ? (
            <form onSubmit={handleLogin} className="login-form">
            <h2>會員登入</h2>
            {error && <p className="error">{error}</p>}
            <div>
                <label htmlFor="username">用戶名：</label>
                <input
                type="text"
                id="username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
                className="input-field"
                />
            </div>
            <div>
                <label htmlFor="password">密碼：</label>
                <input
                type="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="input-field"
                />
            </div>
            <button type="submit" className="button button-m">
                登入
            </button>
            <p>
                <button type="button" onClick={handleForgotPassword} className="link-button">
                    忘記密碼？
                </button>
            </p>
            </form>
        ) : (
            <div className="forgot-password">
                <p>請聯絡網站管理員以取得您的密碼 - webmaster@hocsf.org</p>
                <button onClick={handleBackToLogin} className="button button-m">
                    返回登入
                </button>
            </div>
        )}
        </div>
    );
}

export default LogIn;
